export default __webpack_public_path__ + "static/media/AG15.09fa33ef.mp3";